<div class="pl-md-4 pt-3" *ngIf="loadingCustomer">
  <h2>Loading customer...</h2>
</div>

<div class="pl-md-4 pt-3" *ngIf="customerNotFound">
  <h2>Customer not found</h2>
</div>

<div class="pl-md-4 pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="!loadingCustomer && !customerNotFound && (serverError === null)">
  <div class="floating-alert-container">
    <div class="alert alert-dismissible" role="alert"
         [class.alert-success]="modalResult.status === CallbackResultStatus.success"
         *ngIf="modalResult !== null">
      {{ modalResult.text }}
      <button type="button" class="close" (click)="modalResult = null">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>

  <h2 class="mb-3">Edit Customer Profile</h2>

  <div class="row">
    <div class="col-sm-6">
      <form (submit)="saveCustomer()">

        <div class="form-group">
          <label>Customer ID</label>
          <input class="form-control" disabled [value]="customer.id">
        </div>

        <div class="form-group">
          <label for="firstNameInput">First Name</label>
          <input id="firstNameInput" type="text" class="form-control" name="firstName"
                 [(ngModel)]="customer.first_name">
          <div class="form-text text-danger">{{ customerErrors.first_name }}</div>
        </div>

        <div class="form-group">
          <label for="lastNameInput">Last Name</label>
          <input id="lastNameInput" type="text" class="form-control" name="lastName"
                 [(ngModel)]="customer.last_name">
          <div class="form-text text-danger">{{ customerErrors.last_name }}</div>
        </div>

        <div class="form-group">
          <label for="preferredNameInput">Preferred Name</label>
          <input id="preferredNameInput" type="text" class="form-control" name="preferredName"
                 [(ngModel)]="customer.preferred_name">
          <div class="form-text text-danger">{{ customerErrors.preferred_name }}</div>
        </div>

        <div class="form-group">
          <label for="birthdayInput">Birthday</label>
          <app-date-picker [id]="'birthdayInput'"
                           [(content)]="customer.birthday"></app-date-picker>
          <div class="form-text text-danger">{{ customerErrors.birthday }}</div>
        </div>

        <div class="form-group">
          <label for="emailInput">Email</label>
          <input id="emailInput" type="email" class="form-control" name="email"
                 autocomplete="off"
                 [(ngModel)]="customer.email">
          <div class="form-text text-danger">{{ customerErrors.email }}</div>
        </div>

        <div class="form-group">
          <label for="homeLocationSelect">Home Location</label>
          <select id="homeLocationSelect" class="custom-select" name="homeLocationSelect"
                  [(ngModel)]="customer.home_location_id">
            <option *ngIf="!customer.home_location_id" [ngValue]="customer.home_location_id">---</option>
            <option *ngFor="let location of locationService.getLocations()"
                    [ngValue]="location.id">
              {{ location.name }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <button class="btn btn-sm btn-outline-primary float-right mb-2"
                  type="button"
                  (click)="openTakeCustomerWebcamPhotoModal()">
            Take Photo
          </button>
          <div>
            <label for="profileImageInput">Profile Image</label>
            <input id="profileImageInput" class="mb-2 d-block"
                   type="file" accept=".jpg,.jpeg,.png"
                   (change)="attachProfileImageFile($event)">
            <img *ngIf="!customer.profile_image"
                 src="/assets/images/photo_placeholder.png"
                 class="customer-photo my-2">
            <img *ngIf="customer.profile_image"
                 [src]="customer.profile_image"
                 class="customer-photo my-2">
          </div>
        </div>

        <div class="form-group">
          <label for="streetAddress1Input">Street Address 1</label>
          <input id="streetAddress1Input" type="text" class="form-control" name="streetAddress1"
                 [(ngModel)]="customer.address_street_1">
          <div class="form-text text-danger">{{ customerErrors.address_street1 }}</div>
        </div>

        <div class="form-group">
          <label for="streetAddress2Input">Street Address 2</label>
          <input id="streetAddress2Input" type="text" class="form-control" name="streetAddress2"
                 [(ngModel)]="customer.address_street_2">
          <div class="form-text text-danger">{{ customerErrors.address_street2 }}</div>
        </div>

        <div class="form-group">
          <label for="cityInput">City</label>
          <input id="cityInput" type="text" class="form-control" name="city"
                 [(ngModel)]="customer.address_city">
          <div class="form-text text-danger">{{ customerErrors.address_city }}</div>
        </div>

        <div *ngIf="StateCodes[customer.address_country] !== undefined" class="form-group">
          <label for="stateSelect">State/Province</label>
          <select id="stateSelect" class="custom-select" name="state"
                  [(ngModel)]="customer.address_state">
            <option value="">---</option>
            <option *ngFor="let stateOption of StateCodes[customer.address_country]" [ngValue]="stateOption.code">
              {{ stateOption.name }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="countrySelect">Country</label>
          <select id="countrySelect" class="custom-select" name="country"
                  [(ngModel)]="customer.address_country" (ngModelChange)="customer.address_state = ''">
            <option value="">---</option>
            <option [value]="orgService.getISOCountryCode()">{{ orgService.getCountryName() }}</option>
            <option *ngFor="let countryOption of CountryCodes" [ngValue]="countryOption.code">
              {{ countryOption.name }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="postcodeInput">Postcode/Zip Code</label>
          <input id="postcodeInput" type="text" class="form-control" name="postcode"
                 [(ngModel)]="customer.address_postcode">
          <div class="form-text text-danger">{{ customerErrors.address_postcode }}</div>
        </div>

        <div class="form-group">
          <label for="telephoneInput">Telephone</label>
          <input id="telephoneInput" type="text" class="form-control" name="telephone"
                 [(ngModel)]="customer.telephone">
          <div class="form-text text-danger">{{ customerErrors.telephone }}</div>
        </div>

        <div class="form-group">
          <label for="barcodeInput">Barcode</label>
          <div class="float-right">
            <a href="#" *ngIf="!loadingGenerateBarcode"
               (click)="$event.preventDefault();generateBarcode();">
              Generate Barcode
            </a>
            <span *ngIf="loadingGenerateBarcode" class="text-secondary disabled">
              Loading...
            </span>
          </div>
          <input id="barcodeInput" type="text" class="form-control" name="barcode"
                 [(ngModel)]="customer.barcode">
          <div class="form-text text-danger">{{ customerErrors.barcode }}</div>

          <button (click)="downloadPrintableCustomerBarcode()"
                  type="button"
                  class="btn btn-sm btn-outline-primary mt-1"
                  [disabled]="loadingGenerateBarcode || loadingDownloadPrintableCustomerBarcode || !customer.barcode"
                  [class.disabled]="loadingGenerateBarcode || loadingDownloadPrintableCustomerBarcode || !customer.barcode">
              {{ loadingDownloadPrintableCustomerBarcode ? 'Loading...' : 'Print Barcode' }}
            </button>
        </div>

        <div class="form-group">
          <label for="genderSelect">Gender</label>
          <select id="genderSelect" class="custom-select"
                  name="gender"
                  [(ngModel)]="customer.gender">
            <option [value]="Gender.male">Male</option>
            <option [value]="Gender.female">Female</option>
            <option [value]="Gender.nonbinary">Nonbinary</option>
            <option [value]="Gender.prefer_not_to_say">Prefer not to say</option>
            <option [value]="Gender.not_given">Not given</option>
          </select>
          <div class="form-text text-danger">{{ customerErrors.gender }}</div>
        </div>

        <div class="form-group">
          <label for="pronounsInput">Pronouns</label>
          <input id="pronounsInput" type="text" class="form-control" name="pronouns"
                 [(ngModel)]="customer.pronouns">
          <div class="form-text text-danger">{{ customerErrors.pronouns }}</div>
        </div>

        <p class="mb-2"><b>Custom Fields
          <ng-container *ngIf="loadingCustomCustomerFields">
            - Loading
          </ng-container>
        </b></p>

        <div class="form-text text-danger">{{ customerErrors.custom_field_values }}</div>

        <div class="form-group indented-subsection">
          <ng-container *ngIf="!loadingCustomCustomerFields">
            <div class="form-group" *ngFor="let field of customCustomerFields">

              <ng-container *ngIf="field.field_type === CustomCustomerFieldType.checkboxes">
                <ng-container *appVar="getCustomFieldValueMultiple(field) as fieldValues">
                  <label *ngIf="field.name !== ''">{{ field.name }}</label>
                  <div class="form-check" *ngFor="let option of field.options; index as idx">
                    <input class="form-check-input" type="checkbox"
                           name="customFieldCHK{{ field.id }}-{{ idx }}"
                           id="customFieldCHK{{ field.id }}-{{ idx }}"
                           [checked]="fieldValues.includes(option)"
                           (click)="toggleCustomCheckBoxesFieldValue(field, option)">
                    <label class="form-check-label" for="customFieldCHK{{ field.id }}-{{ idx }}">
                      {{ option }}
                    </label>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="field.field_type === CustomCustomerFieldType.dropdown">
                <label *ngIf="field.name !== ''"
                       for="customFieldDRP{{ field.id }}">
                  {{ field.name }}
                </label>
                <select class="custom-select"
                        id="customFieldDRP{{ field.id }}"
                        name="customFieldDRP{{ field.id }}"
                        [(ngModel)]="getCustomFieldValueSingle(field).value">
                  <option *ngFor="let option of field.options" [value]="option">
                    {{ option }}
                  </option>
                </select>
              </ng-container>

              <ng-container *ngIf="field.field_type === CustomCustomerFieldType.radio">
                <ng-container *appVar="getCustomFieldValueSingle(field) as fieldValue">
                  <label *ngIf="field.name !== ''">{{ field.name }}</label>
                  <div class="form-check" *ngFor="let option of field.options; index as idx">
                    <input class="form-check-input" type="radio"
                           id="customFieldRDO{{ field.id }}-{{ idx }}"
                           name="customFieldRDO{{ field.id }}"
                           [(ngModel)]="fieldValue.value"
                           [value]="option">
                    <label class="form-check-label" for="customFieldRDO{{ field.id }}-{{ idx }}">
                      {{ option }}
                    </label>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="field.field_type === CustomCustomerFieldType.singleLineText">
                <label for="customFieldSLT{{ field.id }}">{{ field.name }}</label>
                <input id="customFieldSLT{{ field.id }}"
                       name="customFieldSLT{{ field.id }}"
                       type="text" class="form-control" maxlength="127"
                       [(ngModel)]="getCustomFieldValueSingle(field).value">
              </ng-container>

              <ng-container *ngIf="field.field_type === CustomCustomerFieldType.multipleLineText">
                <label for="customFieldMLT{{ field.id }}">{{ field.name }}</label>
                <textarea id="customFieldMLT{{ field.id }}"
                          name="customFieldMLT{{ field.id }}"
                          class="form-control"
                          [(ngModel)]="getCustomFieldValueSingle(field).value"></textarea>
              </ng-container>

            </div>

            <span class="text-muted" *ngIf="customCustomerFields.length === 0">No custom fields configured</span>
          </ng-container>
        </div>

        <ng-container *ngIf="orgService.getOrganizationConfig() && orgService.getOrganizationConfig().display_email_opt_in">
          <div class="form-group">
            <label for="marketingOptInSelect">Has opted in to marketing communications?</label>
            <select id="marketingOptInSelect" class="custom-select"
                    name="has_opted_in_to_marketing"
                    [(ngModel)]="customer.has_opted_in_to_marketing">
              <option [value]="true">Yes</option>
              <option [value]="false">No</option>
            </select>
            <div class="form-text text-danger">{{ customerErrors.has_opted_in_to_marketing }}</div>
          </div>

          <div class="form-group indented-subsection" *ngIf="hasConnectedMailchimpAccount()">
            <p><b>
              Mailchimp Groups
              <ng-container *ngIf="!(loadingOrgMailchimpGroupCategories || loadingCustomerProfileDetails)">
                -
                <a href="#" (click)="openEditMailchimpGroupsModal();$event.preventDefault();">Edit</a>
              </ng-container>
            </b></p>

            <p class="text-muted" *ngIf="loadingOrgMailchimpGroupCategories || loadingCustomerProfileDetails">
              Loading...
            </p>

            <ng-container *ngIf="!(loadingOrgMailchimpGroupCategories || loadingCustomerProfileDetails)">
              <ng-container *ngFor="let mailchimpGroupCategory of orgMailchimpGroupCategories">
                <p class="mb-0">
                  {{ mailchimpGroupCategory.name }}
                  <span *ngIf="mailchimpGroupCategory.group_type === MailchimpGroupCategoryType.hidden">
                    (Hidden)
                  </span>
                </p>

                <ul class="pl-4">
                  <li *ngFor="let groupName of getCustomerMailchimpGroupNamesInCategory(mailchimpGroupCategory)">
                    {{ groupName }}
                  </li>
                  <li *ngIf="getCustomerMailchimpGroupNamesInCategory(mailchimpGroupCategory).length === 0"
                      class="text-muted">
                    None selected
                  </li>
                </ul>
              </ng-container>

              <p *ngIf="orgMailchimpGroupCategories.length === 0" class="text-muted">
                No Mailchimp groups configured.
              </p>
            </ng-container>
          </div>
        </ng-container>

        <div class="form-group">
          <span>
            Capitan Status:
            <span [class.text-primary]="customer.has_capitan_login">
              {{ getCustomerFieldValue(ProfileField.capitan_status, customer, null, false) }}
            </span>
          </span>
          <ng-container *ngIf="!customer.has_capitan_login">
            <br>
            <button *ngIf="loadingCustomerInvite || customerInviteComplete"
                    class="btn btn-sm btn-outline-secondary mt-1 disabled" disabled>
              {{ loadingCustomerInvite ? 'Loading...': 'Invite sent' }}
            </button>
            <button *ngIf="!(loadingCustomerInvite || customerInviteComplete)"
                    (click)="sendInviteEmail()"
                    type="button"
                    class="btn btn-sm btn-outline-primary mt-1">
              {{ customer.capitan_invite_sent ? 'Resend' : 'Send' }} Invite
            </button>
            <div class="form-text text-danger">{{ customerInviteErrorMessage }}</div>
          </ng-container>
        </div>

        <div class="alert alert-danger" role="alert" *ngIf="customerErrors.non_field_errors">
          {{ customerErrors.non_field_errors }}
        </div>
        <div class="alert alert-danger" role="alert" *ngIf="customerErrorMessage">
          {{ customerErrorMessage }}
        </div>

        <!-- Place save button first so that the enter key press activates it -->
        <button type="submit" class="btn btn-primary mb-5 float-right"
                *ngIf="!loadingCustomerUpdate">
          Save
        </button>
        <button type="submit" class="btn btn-primary mb-5 float-right disabled" disabled
                *ngIf="loadingCustomerUpdate">
          Loading...
        </button>
        <button [routerLink]="'/customers/' + customer.id.toString()"
                class="btn btn-secondary mb-5">
          Cancel
        </button>

      </form>
    </div>
  </div>
</div>
